import { render, staticRenderFns } from "./changelog-link-application.vue?vue&type=template&id=094e72e5"
import script from "./changelog-link-application.vue?vue&type=script&lang=js"
export * from "./changelog-link-application.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports